import { render, staticRenderFns } from "./DashboardUserTable.vue?vue&type=template&id=6799ef90&"
import script from "./DashboardUserTable.vue?vue&type=script&lang=js&"
export * from "./DashboardUserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports